import React, { useState, useEffect, useRef, forwardRef } from "react";
import {Grid,
        Box,
        Tabs,
        Tab,
        AppBar,
        Typography,
        CircularProgress,
        MenuItem
} from "@material-ui/core";
import PropTypes from 'prop-types';
import { Button } from '../../components/Wrappers'
import HistoryIcon from '@material-ui/icons/History';
import ReceiptIcon from '@material-ui/icons/Receipt';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import config from '../../config';
import Widget from '../../components/Widget';
import { sendNotification } from "../../context/UserContext";
import UpdateAsset from '../../components/Asset/UpdateAsset';
import AssetImages from '../../components/Asset/AssetImages';
import SelectCustomer from '../../components/Customer/SelectCustomer';
import UpdateCustomer from '../../components/Customer/UpdateCustomer';
import SelectSite from '../../components/Site/SelectSite';
import UpdateSite from '../../components/Site/UpdateSite';

const EditAsset = forwardRef((props, ref) => {

    const classes = useStyles();
    const [locationState, setLocationState] = useState(props.location.state);
    const [paramsId, setParamsId] = useState(props.match.params.id);
    const [asset, setAsset] = useState(undefined);

    const [isSaving, setIsSaving] = useState(false);
    const [isSelectCustomerValid, setIsSelectCustomerValid] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(undefined);
    const [isSelectSiteValid, setIsSelectSiteValid] = useState(false);
    const [selectedSite, setSelectedSite] = useState(undefined);
    const [isCreateAssetValid, setIsCreateAssetValid] = useState(false);

    const [siteTabValue, setSiteTabValue] = useState(0);
    const [customerTabValue, setCustomerTabValue] = useState(0);

    const assetWidgetRef = useRef(null);

    function TabPanel(props) {
      const { children, value, index, ...other } = props;

      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
        >
          {value === index && (
            <Box p={3}>
              <Typography component="div">{children}</Typography>
            </Box>
          )}
        </div>
      );
    }

    TabPanel.propTypes = {
      children: PropTypes.node,
      index: PropTypes.any.isRequired,
      value: PropTypes.any.isRequired,
    };

    function a11yProps(index) {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }

    useEffect(() => {
        let mounted = true;
        const assetId = locationState === undefined ? paramsId : locationState.assetId;
        async function fetchData() {

            const response = await ttAPI.loadAsset(assetId);
            if (response !== undefined && response !== null) {
              if(mounted){
                  setAsset(response);
              }

              const customerLoaded = await ttAPI.getCustomerById(response.customer_id);
              if(mounted){
                  setSelectedCustomer(customerLoaded);
              }

              const siteLoaded = await ttAPI.getSiteById(response.site_id);
              if(mounted){
                  setSelectedSite(siteLoaded);
              }
            }

        }


        if (assetId !== undefined && assetId > 0) {
            fetchData();
        }

        return () => mounted = false;
    },[locationState, paramsId]);

    const disableSaveButton = () => {
      return isSaving || !(isSelectCustomerValid && isSelectSiteValid && isCreateAssetValid);
    }

    function handleSiteTabChange(event, newValue) {
      setSiteTabValue(newValue);
    }

    function handleCustomerTabChange(event, newValue) {
      setCustomerTabValue(newValue);
    }

    function onSelectCustomer(customer) {
      setSelectedCustomer(customer);
      setAsset({
        ...asset,
        customer_id: customer === undefined || customer === null ? -1 : customer.id
      });
    }

    function onSelectCustomerFormUpdated(isValid) {
      setIsSelectCustomerValid(isValid);
    }

    function onSelectSite(site) {
      setSelectedSite(site);
      setAsset({
        ...asset,
        site_id: site === undefined || site === null ? -1 : site.id
      });
    }

    function onSelectSiteFormUpdated(isValid) {
      setIsSelectSiteValid(isValid);
    }

    function getSiteName() {
      return selectedSite !== undefined && selectedSite !== null ? selectedSite.name : '';
    }

    const handleSave = async () => {
        const assetToSend = { ...asset };
        assetToSend.tested = assetToSend.tested.replace('T', ' ');
        assetToSend.expires = assetToSend.expires.replace('T', ' ');

        if (assetToSend.custom_properties !== null &&
            assetToSend.custom_properties !== undefined &&
            assetToSend.custom_properties !== '') {
            assetToSend.custom_properties = JSON.stringify(assetToSend.custom_properties);
        }

        if (assetToSend.disposal_date !== null &&
            assetToSend.disposal_date !== undefined &&
            assetToSend.disposal_date !== '') {
            assetToSend.disposal_date = assetToSend.disposal_date.replace('T', ' ');
        }

        setIsSaving(true);
        const response = await ttAPI.saveAsset(assetToSend);
        setIsSaving(false);

        if (response && response.ok === "true") {
            const message = response.warning
                ? `Success - Asset ${response.id} Updated. ${response.warning}`
                : `Success - Asset ${response.id} Updated.`;

            sendNotification(
                response.warning ? 'warning' : 'success',
                message,
                classes
            );

            // Give the user time to read the notification
            setTimeout(() => {
                window.location.reload();
            }, response.warning ? 7000 : 1000);
        }
        else {
            sendNotification(
                'error',
                response && response.message
                    ? response.message
                    : 'Error - updating asset.',
                classes
            );
        }
    }

    function onAssetFormUpdated(isValid) {
        setIsCreateAssetValid(isValid);
    }

    function onAssetUpdated(updatedAsset) {
        setAsset({
          ...asset,
          location: updatedAsset.location,
          description: updatedAsset.description,
          serial: updatedAsset.serial,
          make: updatedAsset.make,
          model: updatedAsset.model,
          notes: updatedAsset.notes,
          tested: updatedAsset.tested,
          expires: updatedAsset.expires,
          disposed: updatedAsset.disposed,
          disposal_code: updatedAsset.disposal_code,
          disposal_date: updatedAsset.disposal_date
        });
    }

    function onUpdateCustomerSuccess() {

    }

    function onUpdateSiteSuccess() {

    }

    const downloadHistory = () => {
      if (asset.id === undefined) {
          sendNotification('error','Cannot download history, no asset id.');
      }
      else {
          window.open(`${config.clientApi}/reports/audit/asset?id=${asset.id}`,'_blank');
      }

      assetWidgetRef.current.closeWidgetMoreMenu();
    }

  return (
    <div className={classes.contentDiv}>

      {asset &&
        <Grid container spacing={4}>
            <Grid item xs={12} md={6} sm={6}>
            <Box display={'flex'}
                justifyContent={'flex-end'}
                style={{marginBottom: '-20px', marginRight: '60px', marginTop: '20px'}}
            >
                <Button style={{position: 'fixed', zIndex: '10'}}
                    className={classes.saveEditAssetButton}
                    variant="contained"
                    color="primary"
                    disabled={disableSaveButton()}
                    onClick={handleSave}
                >
                {isSaving && <span className={classes.savebuttonText}><CircularProgress size={25}/> Saving Asset...</span>}
                {!isSaving && <span className={classes.savebuttonText}>Save Asset</span>}
                </Button>
            </Box>
                <Widget
                  title={<><div className={classes.editAsset}>
                             {`EDIT - Asset ${asset.code} - ${asset.passed ? ' PASSED' : ' FAILED'}`}&nbsp;
                             {asset.passed || (asset.failed_reason === null || asset.failed_reason === undefined || asset.failed_reason === '') ? null : `(${asset.failed_reason})`}&nbsp;
                              <div className={classes.reportLinks}>
                             {asset.link &&
                             <span className={classes.report}><InsertDriveFileIcon/><a className={classes.externalLink} href={asset.link} rel="noopener noreferrer" target="_blank">
                             View Inspection Report
                             </a></span>}
                             {asset.pv_link && (
                              <span className={classes.report}>
                                <InsertDriveFileIcon />
                                &nbsp;
                                <a
                                  className={classes.externalLink}
                                  href={asset.pv_link}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  View Periodic Inspection Report
                                </a>
                              </span>
                            )}
                            </div>
                            </div>
                         </>}
                  upperTitle
                  className={classes.card}
                  bodyClass={classes.fullHeightBody}
                  ref={assetWidgetRef}
                  menuItems={<div>
                             <MenuItem onClick={downloadHistory}>
                                           <HistoryIcon/><Typography>Download History</Typography>
                                        </MenuItem>
                             </div>
                           }>


                    <div style={{height: '35px'}}></div>

                    <div style={{marginBottom: '20px'}}>
                    <SelectCustomer labelName="Customer" disabled={true}
                                  selectedCustomer={selectedCustomer}
                                  onSelect={onSelectCustomer}
                                  onFormUpdated={onSelectCustomerFormUpdated}/>
                    </div>

                    <SelectSite labelName="Site" disabled={true}
                                  selectedSite={selectedSite}
                                  customerId={selectedCustomer !== undefined ? selectedCustomer.id : -1}
                                  onSelect={onSelectSite}
                                  onFormUpdated={onSelectSiteFormUpdated}/>


                    <UpdateAsset asset={asset}
                                 onFormUpdated={onAssetFormUpdated}
                                 onAssetUpdated={onAssetUpdated}/>

                     <div className={classes.bottomMenu}>
                         <div>
                         <Box
                             display={'flex'}
                             justifyContent={'flex-end'}
                         >
                             <Button className={classes.saveEditAssetButtonBottom}
                                 color="primary"
                                 disabled={disableSaveButton()}
                                 onClick={handleSave}
                             >
                             {isSaving && <span className={classes.savebuttonText}><CircularProgress size={25}/> Saving Asset...</span>}
                             {!isSaving && <span className={classes.savebuttonText}>Save Asset</span>}
                             </Button>
                         </Box>
                         </div>
                     </div>
                </Widget>
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <Grid container spacing={4}>
              {selectedSite && selectedSite.id > 0 && <Grid item xs={12} md={12} sm={12}>
                <Widget
                 className={classes.formDisplay}
                 disableWidgetMenu noHeader>
                 <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                   <Tabs value={siteTabValue}
                         onChange={handleSiteTabChange}
                         indicatorColor="primary"
                         textColor="primary"
                         variant="fullWidth">
                     <Tab {...a11yProps(0)} label="SITE NOTES"
                                            value={0}/>
                     <Tab {...a11yProps(1)} label="SITE DETAILS"
                                            value={1}/>
                   </Tabs>
                 </AppBar>
                 {/*<TabPanel value={siteTabValue} index={0}>
                    <UpdateSite key={selectedSite.id} isNotesOnly={true} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                  </TabPanel>
                  <TabPanel value={siteTabValue} index={1}>
                    <UpdateSite key={selectedSite.id} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                  </TabPanel>*/}
                  <div
                    role="tabpanel"
                    id="simple-tabpanel-site-0"
                    aria-labelledby="simple-tab-site-0"
                  >
                    {siteTabValue === 0 && (
                      <Box p={3}>
                        <Typography component="div">
                        <UpdateSite key={selectedSite.id} isNotesOnly={true} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                        </Typography>
                      </Box>
                    )}
                  </div>

                  <div
                    role="tabpanel"
                    id="simple-tabpanel-site-1"
                    aria-labelledby="simple-tab-site-1"
                  >
                    {siteTabValue === 1 && (
                      <Box p={3}>
                        <Typography component="div">
                        <UpdateSite key={selectedSite.id} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                        </Typography>
                      </Box>
                    )}
                  </div>
                </Widget>
              </Grid>}
              {selectedCustomer && selectedCustomer.id > 0 && <Grid item xs={12} md={12} sm={12}>
                <Widget
                 className={classes.formDisplay}
                 disableWidgetMenu noHeader>
                 <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                   <Tabs value={customerTabValue}
                         onChange={handleCustomerTabChange}
                         indicatorColor="primary"
                         textColor="primary"
                         variant="fullWidth">
                     <Tab {...a11yProps(0)} label="CUSTOMER NOTES"
                                            value={0}/>
                     <Tab {...a11yProps(1)} label="CUSTOMER DETAILS"
                                            value={1}/>
                   </Tabs>
                 </AppBar>
                 {/*<TabPanel value={customerTabValue} index={0}>
                    <UpdateCustomer key={selectedCustomer.id} isNotesOnly={true} createdCustomer={selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                  </TabPanel>
                  <TabPanel value={customerTabValue} index={1}>
                    <UpdateCustomer key={selectedCustomer.id} createdCustomer={selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                  </TabPanel>*/}

                  <div
                    role="tabpanel"
                    id="simple-tabpanel-customer-0"
                    aria-labelledby="simple-tab-customer-0"
                  >
                    {customerTabValue === 0 && (
                      <Box p={3}>
                        <Typography component="div">
                        <UpdateCustomer key={selectedCustomer.id} isNotesOnly={true} createdCustomer={selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                        </Typography>
                      </Box>
                    )}
                  </div>

                  <div
                    role="tabpanel"
                    id="simple-tabpanel-customer-1"
                    aria-labelledby="simple-tab-customer-1"
                  >
                    {customerTabValue === 1 && (
                      <Box p={3}>
                        <Typography component="div">
                        <UpdateCustomer key={selectedCustomer.id} createdCustomer={selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                        </Typography>
                      </Box>
                    )}
                  </div>

                </Widget>

              </Grid>}

              {asset && <Grid item xs={12} md={12} sm={12}>
                <Widget
                 className={classes.formDisplay}
                 disableWidgetMenu noHeader>
                    <AssetImages asset={asset}/>
                </Widget>

              </Grid>}
              </Grid>
            </Grid>
        </Grid>
        }
    </div>
  );
});
export default EditAsset;
